import React, {useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import Back from '../../components/Back';
import Icon from '../../components/Icon';
import {Loading} from '../../components/Query';
import {MUTATION_STUDY_PASS_INTERMEDIATE, QUERY_STUDY_LIST} from '../Study/graphql';
import {QUERY_LESSON_LIST} from '../Lesson/graphql';
import TaskList from './List';

const TaskIntermediates = ({match}) => {
  const start = (parseInt(match.params.id) - 1) * 5;

  const [lessonId, setLessonId] = useState(start + 1);
  const [isPass, setIsPass] = useState(false);
  const [showInfo, setShowInfo] = useState(true);

  const lessonListQuery = useQuery(QUERY_LESSON_LIST);
  const lessonList = lessonListQuery.data ? lessonListQuery.data.lessonList : [];
  const lessons = {
    1: lessonList.find(x => x.level === start + 1),
    2: lessonList.find(x => x.level === start + 2),
    3: lessonList.find(x => x.level === start + 3),
    4: lessonList.find(x => x.level === start + 4),
    5: lessonList.find(x => x.level === start + 5),
  };

  const studyListQuery = useQuery(QUERY_STUDY_LIST);
  const studyList = studyListQuery.data ? studyListQuery.data.studyList : [];
  const studies = {
    1: studyList.find(x => x.lesson.level === start + 1),
    2: studyList.find(x => x.lesson.level === start + 2),
    3: studyList.find(x => x.lesson.level === start + 3),
    4: studyList.find(x => x.lesson.level === start + 4),
    5: studyList.find(x => x.lesson.level === start + 5),
  };

  const [pass] = useMutation(MUTATION_STUDY_PASS_INTERMEDIATE, {
    onCompleted: data => {
      if (data.studyPassIntermediate.obj) {
        studyListQuery.refetch();
      }
    },
  });

  if (lessonListQuery.loading || studyListQuery.loading) {
    return <Loading />;
  }

  const passed =
    studies[1].intermediatePassed &&
    studies[2].intermediatePassed &&
    studies[3].intermediatePassed &&
    studies[4].intermediatePassed &&
    studies[5].intermediatePassed;

  return (
    <div className="py-4">
      {showInfo && (
        <div className="alert alert-info text-center">
          <div>Пройдите тест-повторение из грамматики пройденных уроков</div>
          <button onClick={() => setShowInfo(false)} type="button" className="btn btn-light btn-sm mt-2">
            <span>Закрыть</span>
          </button>
        </div>
      )}
      <div className="row gx-3 align-items-center">
        <div className="col-auto">
          <Back />
        </div>
        <div className="col-auto font-4 fw-bold text-uppercase">Тест повторение №{match.params.id}</div>
        <div className="col-auto">
          <Icon name={passed ? 'check' : 'dot-circle'} color={passed ? 'success' : 'primary'} />
        </div>
        {/* {passed ? (
          <span className="col-auto text-success">Повторение пройдено</span>
        ) : isPass ? (
          <div>
            <div className="text-end">Вы не прошли задания, вы точно хотите пропустить?</div>
            <div className="row justify-content-center mt-2">
              <div className="col-auto ms-auto">
                <button onClick={() => pass({variables: {input: {id: studies[5].id}}})} className="btn btn-primary">
                  Пропустить
                </button>
              </div>
              <div className="col-auto ms-2">
                <button onClick={() => setIsPass(false)} className="btn btn-secondary">
                  Отмена
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-auto ms-auto">
            <button onClick={() => setIsPass(true)} className="btn btn-secondary">
              Пропустить урок
            </button>
          </div>
        )} */}
      </div>
      <ul className="nav nav-tabs mt-4">
        {[1, 2, 3, 4, 5].map(item => (
          <li key={item} className="nav-item">
            <button
              onClick={() => setLessonId(start + item)}
              className={`nav-link ${lessonId === start + item && 'active'}`}
            >
              <span className="me-2">Урок №{start + item}</span>
              {studies[item].intermediatePassed === true && <Icon name="check" color="success" />}
              {studies[item].intermediatePassed === false && studies[item].finalPassed === false && (
                <Icon name="times" color="danger" />
              )}
            </button>
          </li>
        ))}
      </ul>
      <div className="bg-white px-4 py-3 border border-top-0">
        {[1, 2, 3, 4, 5].map(
          item =>
            lessonId === start + item && (
              <TaskList key={item} lesson={lessons[item]} study={studies[item]} kind="INTERMEDIATE" />
            ),
        )}
      </div>
    </div>
  );
};

export default TaskIntermediates;
